import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeviceService } from './device.service';

@Injectable()
export class DeviceTokenInterceptor implements HttpInterceptor {
  constructor(private deviceService: DeviceService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const newReq = req.clone({
      setHeaders: {
        'Device-Token': this.deviceService.getDeviceToken(),
      },
    });
    return next.handle(newReq);
  }
}
